import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { Copy, Trash2 } from 'lucide-react';
import { deleteTransfer, formatBytes, getMine } from './api';

const MyTransfers = () => {
  const [rows, setRows] = useState(null);

  const load = useCallback(() => {
    getMine().then(setRows).catch(() => setRows([]));
  }, []);
  useEffect(load, [load]);

  const copy = async (token) => {
    await navigator.clipboard.writeText(`${window.location.origin}/t/${token}`);
    toast.success('Link copied');
  };

  const remove = async (id) => {
    if (!window.confirm('Delete this transfer and its files now?')) return;
    try {
      await deleteTransfer(id);
      load();
    } catch {
      toast.error('Could not delete the transfer');
    }
  };

  return (
    <div className="space-y-4" data-testid="portal-transfers">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold">My Transfers</h2>
        <Link to="/transfer" className="text-sm font-medium underline">Send files</Link>
      </div>
      {rows === null && <p className="text-slate-500">Loading…</p>}
      {rows && rows.length === 0 && <p className="text-slate-500">You have no active transfers.</p>}
      {rows && rows.length > 0 && (
        <ul className="divide-y rounded-lg border bg-white">
          {rows.map((r) => (
            <li key={r.id} className="p-4 flex flex-wrap items-center gap-3">
              <div className="flex-1 min-w-[12rem]">
                <p className="font-medium">{r.title || `${r.file_count} file${r.file_count !== 1 ? 's' : ''}`}</p>
                <p className="text-xs text-slate-500">
                  {formatBytes(r.total_bytes)} · {r.download_count} download{r.download_count !== 1 ? 's' : ''} ·
                  {r.expires_at ? `expires ${new Date(r.expires_at).toLocaleDateString()}` : 'never expires'}
                </p>
              </div>
              <button type="button" onClick={() => copy(r.token)} className="min-h-[44px] px-3 inline-flex items-center gap-2 rounded border">
                <Copy className="w-4 h-4" /> Copy link
              </button>
              <button type="button" onClick={() => remove(r.id)} aria-label="Delete transfer"
                className="min-h-[44px] min-w-[44px] inline-flex items-center justify-center rounded border text-red-600">
                <Trash2 className="w-4 h-4" />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default MyTransfers;
